import { expVal } from '@confluence/feature-experiments';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

/**
 * Hook to check whether smart folders are supported in this environment.
 *
 * This checks all prerequisite conditions (but NOT space-level settings):
 * 1. Rovo is enabled for this site
 * 2. The `confluence_folder_view` experiment is enabled
 * 3. The `confluence_smart_folders_milestone_1` experiment is enabled
 *
 * Use this hook to gate network requests (e.g., the space-type-settings GraphQL query)
 * so they are not fired when the feature is known to be disabled.
 *
 * For the full check including space-level settings, use `useIsSmartFoldersEnabled`.
 */
export const useIsSmartFoldersSupported = (): boolean => {
	const { isRovoEnabled } = useSessionData();

	return (
		isRovoEnabled &&
		expVal('confluence_folder_view', 'isEnabled', false) &&
		expVal('confluence_smart_folders_milestone_1', 'isEnabled', false)
	);
};
